import React, { useEffect, useState } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { allReport, blockUnblockedReport, warnToReportedUser } from "../redux/action/reportAction";
import NoRecord from "../components/other/NoRecord";
import { pipTimeView, pipViewDate2 } from "../utils/pip";
import Loader from "../components/other/Loader";
import ReactPagination from "../components/reactPagination";
import PaginationDropdown from "../components/PaginationDropdown";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import { message } from "antd";
import moment from "moment";

const UserReport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isToggle } = useSelector((state) => state.authReducer);
  const { isLoading, allreportList } = useSelector(
    (state) => state.reportReducer
  );
  const [selectedImage, setSelectedImage] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);
  const [selectedUser, setSelectedUser] = useState();
  const [filterValue, setFilterValue] = useState('');
  const [selectedDate, setSelectedDate] = useState('');

  useEffect(() => {
    dispatch(allReport());
  }, []);

  const handleStatus = (id, status) => {
    const blockStatus = status === 0 ? true : false;
    const values = {
      user_id: id,
      block_status: blockStatus,
    };

    const callback = (response) => {
      if (response.success) dispatch(allReport());
    };
    dispatch(blockUnblockedReport({ payload: values, callback }));
  };

  const displayData = filterValue == '' ? allreportList : filterValue == "high" ? [...allreportList].sort((a, b) => a.report_count - b.report_count) :
    filterValue == "high" ? [...allreportList].sort((a, b) => b.report_count - a.report_count) : filterValue == 'new' ? [...allreportList].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) : filterValue == "date" ? selectedDate == '' ? allreportList : allreportList.filter(user => {
      console.log(user, moment.utc(user?.created_at).format("YYYY-MM-DD"), '===', moment.utc(selectedDate).format("YYYY-MM-DD"))
      const userDate = moment.utc(user?.created_at).format("YYYY-MM-DD") == moment.utc(selectedDate).format("YYYY-MM-DD")
      return userDate;
    }) : allreportList;


  const paginatedUserReport = displayData?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleSendWarning = (value) => {
    const data = {
      user_id: `${value?.receiver?.id}`
    }
    const callback = (response) => {
      if (response.success) {
        dispatch(allReport());
      };
    };
    dispatch(warnToReportedUser({ payload: data, callback }));
  };

  const formattedLookingFor = (lookingFor) => {
    // If it's a string, ensure proper formatting (split and join again)
    return lookingFor
      ? lookingFor
        .split(",")
        .map((part) => part.trim())
        .join(", ")
      : "";
  };

  if (isLoading) {
    return <Loader />;
  }

  console.log("filterValue", { filterValue });

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div class="ct_right_content">
          <Header />

          <div class="ct_inner_dashbaord_main">
            <div class="row ">
              <div class="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                <div class="">
                  <div class="">
                    <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                      <ul class="d-flex align-items-center gap-2 mb-0">
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            All Reported Users
                          </h4>
                        </li>
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            <i class="bi bi-dot"></i>
                          </h4>
                        </li>
                        <li>
                          {" "}
                          <h4 class="ct_fs_20 ct_ff_roboto ct_fw_600 mb-0">
                            {allreportList.length}{" "}
                            {allreportList.length <= 1 ? "User" : "Users"}{" "}
                          </h4>
                        </li>
                      </ul>
                      <div class="ct_left_header_cnt">
                        <div>
                          <label class="mb-2 ct_fw_600">
                            Sort by number of time reported
                          </label>
                          <select
                            name="status"
                            className="form-control ct_input ct_pointer_curser"
                            value={filterValue}
                            onChange={(e) => setFilterValue(e.target.value)}
                          >
                            <option value="">All</option>
                            <option value='high'>Highest To Lowest</option>
                            <option value='low'>Lowest To Highest</option>
                            <option value='new'>Newest To Oldest</option>
                          </select>
                        </div>
                        <div>
                          <label class="mb-2 ct_fw_600">
                            Filter by date
                          </label>
                          <input
                            type="date" className="form-control ct_input"
                            onChange={(e) => {
                              setFilterValue('date')
                              setSelectedDate(e.target.value)
                            }}
                            value={selectedDate}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table ct_custom_table">
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th>User Image</th>
                            <th>Name & Location</th>
                            <th>Gender</th>
                            <th>Age</th>
                            <th>Reported At</th>
                            <th>Report Reason</th>
                            <th>No. of times Reported</th>
                            <th>Status</th>
                            <th>Action</th>
                            <th>View</th>
                          </tr>
                        </thead>

                        <tbody>
                          {paginatedUserReport &&
                            paginatedUserReport.length !== 0 ? (
                            paginatedUserReport.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="d-flex align-items-center gap-2">
                                      {item?.receiver?.images &&
                                        item?.receiver?.images?.length != 0 && (
                                          <img
                                            src={
                                              item?.receiver?.images.length != 0
                                                ? item?.receiver?.images[0]
                                                : "./user_profile.png"
                                            }
                                            alt=""
                                            // data-bs-toggle="modal"
                                            // data-bs-target="#ct_user_img_preview"
                                            class="ct_img_56"
                                          // onClick={() => setSelectedUser(item)}
                                          />
                                        )}
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2">
                                      <div>
                                        <h5 class="ct_fs_14 ct_fw_700 mb-0">
                                          {item?.receiver?.name ?? ''}
                                        </h5>
                                        <p class="mb-0 ct_fw_500">
                                          <i class="bi bi-geo-alt-fill me-1"></i>
                                          {item?.receiver?.city ?? ''},
                                          {item?.receiver?.country ?? ''}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p class="mb-1 ct_fw_600 ct_fs_16">
                                        {item?.receiver?.gender ?? ''}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p class="mb-0 ct_fw_600 ct_fs_16">
                                        {item?.receiver?.age ?? 0} Years
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p class="mb-1 ct_fw_600 ct_fs_16 ct_orange_text">
                                        {" "}
                                      </p>
                                      <p class="mb-0 ct_fw_600 ct_fs_16">
                                        <span>
                                          {" "}
                                          {pipViewDate2(item?.created_at)}
                                        </span>{" "}
                                        <span class="ms-2">
                                          {" "}
                                          {pipTimeView(item?.created_at)}
                                        </span>
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p className="mb-0 ct_white_space_3_dot_12">
                                        {" "}
                                        {item?.comment ?? ''}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p className="mb-0 text-center">
                                        {" "}
                                        {item?.report_count ?? 0}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p
                                        className={`mb-0 ct_fw_600 ct_fs_16 ct_fw_600  ${item?.receiver?.is_blocked === 0
                                          ? "ct_green_text"
                                          : "ct_red_text"
                                          }`}
                                      >
                                        {item?.receiver?.is_blocked === 0
                                          ? "Active"
                                          : "Blocked"}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-ceneter gap-2">
                                      <select
                                        style={{ width: "120px" }}
                                        class="form-control ct_input ct_pointer_curser ct_select_transparent"
                                        onChange={() =>
                                          handleStatus(
                                            item?.reciver_id,
                                            item?.receiver?.is_blocked
                                          )
                                        }
                                        value={
                                          item?.receiver?.is_blocked === 0
                                            ? "0"
                                            : "1"
                                        }
                                      >
                                        <option value="0">Activate</option>
                                        <option value="1">Block</option>
                                      </select>
                                      <button className="ct_orange_btn   d-flex  align-items-center justify-content-center  mx-auto" style={{ borderRadius: "5px", height: "40px" }} onClick={() => handleSendWarning(item)}>Warning</button>
                                    </div>

                                  </td>
                                  <td class="text-center">
                                    <div>
                                      <i
                                        class="fa-solid fa-eye ct_pointer_curser"
                                        data-bs-toggle="modal"
                                        data-bs-target="#ct_group_report_detail_modal"
                                        onClick={() => setSelectedUser(item)}
                                      ></i>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={11}>
                                <NoRecord />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {paginatedUserReport && paginatedUserReport?.length != 0 && (
              <>
                <div className="d-flex justify-content-between align-items-center mt-4">
                  <div>
                    <PaginationDropdown
                      onChange={(val) => {
                        setUserPerPages(val);
                        setCurrentPage(0);
                      }}
                    />
                  </div>
                  <div>
                    <ReactPagination
                      pageCount={Math.ceil(
                        allreportList?.length / usersPerPage
                      )}
                      onPageChange={handlePageClick}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </main>

      {/* image preview modal */}
      <div
        class="modal fade ct_assets_modal"
        id="ct_user_img_preview"
        tabindex="-1"
        aria-labelledby="ct_user_img_previewLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header pb-0 border-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body mt-0">
              <img
                src={selectedUser?.receiver?.images[0] || "./user_profile.png"}
                alt=""
                class="ct_img_400_big"
              />
            </div>
          </div>
        </div>
      </div>
      {/* details modal */}

      <div
        class="modal fade modal-lg"
        id="ct_group_report_detail_modal"
        tabindex="-1"
        aria-labelledby="ct_group_report_detail_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header border-0 pb-0">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="ct_gropp_detail_modal_main">
                <div class="row align-items-center">
                  <div class="col-xl-4 col-md-5 mb-4 mb-md-0">
                    <figure>
                      <div class="ct_user_img_1">
                        <img
                          src={
                            selectedUser?.receiver?.images.length != 0
                              ? selectedUser?.receiver?.images[0]
                              : "./user_profile.png"
                          }
                          alt=""
                        />
                      </div>
                    </figure>
                  </div>
                  <div class="col-xl-8 col-md-7 mb-4 mb-md-0">
                    <div>
                      <div>
                        <div class=" ct_mb_20">
                          <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">Name</h4>
                          <ul>
                            <li>{selectedUser?.receiver?.name ?? ''}</li>
                          </ul>
                        </div>
                        <div class=" ct_mb_20">
                          <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">Gender</h4>
                          <ul>
                            <li>{selectedUser?.receiver?.gender ?? ''}</li>
                          </ul>
                        </div>
                        <div class=" ct_mb_20">
                          <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">Age</h4>
                          <ul>
                            <li>{selectedUser?.receiver?.age ?? 0} Years</li>
                          </ul>
                        </div>
                        <div class=" ct_mb_20">
                          <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">
                            Reported At
                          </h4>
                          <ul>
                            <li>
                              <span>
                                {" "}
                                {pipViewDate2(selectedUser?.created_at)}
                              </span>{" "}
                              <span class="ms-2">
                                {" "}
                                {pipTimeView(selectedUser?.created_at)}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div class=" ct_mb_20">
                          <h4 class="ct_fs_16 ct_fw_600 ct_mb_15">Status</h4>
                          <ul>
                            {selectedUser?.receiver?.is_blocked === 0
                              ? "Active"
                              : "Blocked"}
                          </ul>
                        </div>
                        <div class=" ct_mb_20">
                          <h4 class="ct_fs_16 ct_fw_600 ct_mb_15 ">
                            Report Reason
                          </h4>
                          <p style={{ wordBreak: "break-all" }}>
                            {selectedUser?.comment ?? ''}
                          </p>
                        </div>
                        <div class=" ct_mb_20">
                          <h4 class="ct_fs_16 ct_fw_600 ct_mb_15 ">
                            No. of times Reported
                          </h4>
                          <p style={{ wordBreak: "break-all" }}>
                            {selectedUser?.report_count ?? 0}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserReport;
